module.exports = __webpack_public_path__ + "static/delhi-temperature-ec1bea1fe28fb7caa3bb7ad79a5006d8.gif";